/**
 * Profiles Form - Manejo de formularios de creación y edición de perfiles
 */
export class ProfilesForm {
    constructor() {
        this.init();
    }
    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.initializeForm();
            });
        }
        else {
            this.initializeForm();
        }
    }
    initializeForm() {
        const profileForm = document.getElementById('profileForm');
        if (!profileForm) {
            return;
        }
        this.setupEventListeners();
    }
    setupEventListeners() {
        // Manejar botones de acción usando delegación de eventos
        document.addEventListener('click', (e) => {
            const target = e.target;
            const button = target.closest('[data-action]');
            if (!button) {
                return;
            }
            const action = button.getAttribute('data-action');
            switch (action) {
                case 'select-all':
                    e.preventDefault();
                    this.selectAllPermissions();
                    break;
                case 'clear-all':
                    e.preventDefault();
                    this.clearAllPermissions();
                    break;
                case 'restore-original':
                    e.preventDefault();
                    this.restoreOriginalPermissions(button);
                    break;
            }
        });
        // Validación del formulario
        // const profileForm = document.getElementById('profileForm');
        // if (profileForm) {
        //     profileForm.addEventListener('submit', (e) => this.handleFormSubmit(e));
        // }
    }
    selectAllPermissions() {
        document.querySelectorAll('input[name="permissions[]"]').forEach(checkbox => {
            checkbox.checked = true;
        });
    }
    clearAllPermissions() {
        document.querySelectorAll('input[name="permissions[]"]').forEach(checkbox => {
            checkbox.checked = false;
        });
    }
    restoreOriginalPermissions(button) {
        const originalData = button.getAttribute('data-original');
        if (!originalData) {
            console.warn('No se encontraron datos originales en el botón');
            this.showAlert('No se pueden restaurar los permisos originales.', 'warning');
            return;
        }
        try {
            const originalPermissions = JSON.parse(originalData);
            let checkCount = 0;
            const checkboxes = document.querySelectorAll('input[name="permissions[]"]');
            checkboxes.forEach((checkbox) => {
                const checkboxElement = checkbox;
                const numberValue = parseInt(checkboxElement.value, 10);
                const isChecked = originalPermissions.includes(numberValue);
                checkboxElement.checked = isChecked;
                if (isChecked) {
                    checkCount++;
                }
            });
            this.showAlert(`Se restauraron ${checkCount} permisos correctamente.`, 'success');
        }
        catch (error) {
            this.showAlert('Error al restaurar los permisos originales.', 'danger');
        }
    }
    // private handleFormSubmit(e: Event): void {
    //     const nameInput = document.getElementById('name_rol') as HTMLInputElement;
    //     if (!nameInput) {
    //         return;
    //     }
    //     const name = nameInput.value.trim();
    //     if (name === '') {
    //         e.preventDefault();
    //         this.showAlert('Por favor ingresa el nombre del perfil.', 'danger');
    //         return;
    //     }
    //     if (name.length < 3) {
    //         e.preventDefault();
    //         this.showAlert('El nombre del perfil debe tener al menos 3 caracteres.', 'danger');
    //         return;
    //     }
    // }
    showAlert(message, type) {
        // Crear elemento de alerta
        const alertDiv = document.createElement('div');
        alertDiv.className = `alert alert-${type} alert-dismissible fade show`;
        alertDiv.setAttribute('role', 'alert');
        alertDiv.innerHTML = `
            ${message}
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        `;
        // Insertar al inicio del formulario
        const form = document.getElementById('profileForm');
        if (form) {
            form.insertBefore(alertDiv, form.firstChild);
            // Auto-cerrar después de 5 segundos
            setTimeout(() => {
                alertDiv.remove();
            }, 5000);
        }
    }
}
export default ProfilesForm;
